export const TEAM_COLORS = ['#9FA6B2', '#374151', '#9F46F4', '#FF7511', '#E02424', '#FFD100', '#0064FB', '#057A55'];
